import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import type {
  ProductListApiParams,
  ProductListApiResponse,
} from './product-list-api.type';
import { request } from '../utils';

export const productListApiPath = '/rest/v2/trplus/productList';

export type UseProductListApiOptions = Omit<
  UseQueryOptions<
    ProductListApiResponse,
    unknown,
    ProductListApiResponse,
    [string, Pick<ProductListApiParams, 'skus'>]
  >,
  'queryKey' | 'queryFn'
>;

export function useProductListApi(
  params: Pick<ProductListApiParams, 'skus'>,
  options?: UseProductListApiOptions
) {
  return useQuery({
    queryKey: ['productList', params],
    queryFn: async () => {
      const response = await request<ProductListApiResponse>({
        method: 'post',
        url: productListApiPath,
        data: { ...params, siteId: 'tlw' },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
        devHost: true,
      });
      return response;
    },
    ...options,
  });
}
